import { API_ROOT } from '../../config/config'
import { doGet } from './utils'

export const getReviewHistory = (projectId) => {
  const url = `${API_ROOT}/reviewer/${projectId}/history`
  return doGet(url)
}

export const getFilterHistory = (projectId) => {
  const url = `${API_ROOT}/reviewer/${projectId}/filter`
  return doGet(url)
}

export const getProposalHistory = (projectId) => {
  const url = `${API_ROOT}/review/${projectId}/proposal/history`
  return doGet(url)
}
